module.exports = __webpack_public_path__ + "static/media/5.33fce3eb.jpg";